// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import TenantPhotoProduct from "./tenant-photo-product.js"

const modelClassData = {
  "attributes": {
    "cookies_and_privacy_policy": {
      "column": null,
      "name": "cookies_and_privacy_policy",
      "selected_by_default": null,
      "translated": true
    },
    "default_tenant_photo_sheet_product_id": {
      "column": {
        "default": null,
        "name": "default_tenant_photo_sheet_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "default_tenant_photo_sheet_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "greeter_text": {
      "column": {
        "default": null,
        "name": "greeter_text",
        "null": true,
        "type": "string"
      },
      "name": "greeter_text",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "opening_hours": {
      "column": {
        "default": null,
        "name": "opening_hours",
        "null": true,
        "type": "text"
      },
      "name": "opening_hours",
      "selected_by_default": null,
      "translated": false
    },
    "pick_up_enabled": {
      "column": {
        "default": true,
        "name": "pick_up_enabled",
        "null": false,
        "type": "boolean"
      },
      "name": "pick_up_enabled",
      "selected_by_default": null,
      "translated": false
    },
    "terms_and_conditions": {
      "column": null,
      "name": "terms_and_conditions",
      "selected_by_default": null,
      "translated": true
    },
    "vimeo_greeter_identifier": {
      "column": {
        "default": null,
        "name": "vimeo_greeter_identifier",
        "null": true,
        "type": "string"
      },
      "name": "vimeo_greeter_identifier",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "TenantShopSetting",
  "collectionKey": "tenant_shop_settings",
  "collectionName": "tenant_shop_settings",
  "i18nKey": "tenant_shop_setting",
  "camelizedLower": "tenantShopSetting",
  "name": "TenantShopSetting",
  "nameDasherized": "tenant-shop-setting",
  "pluralName": "tenant_shop_settings",
  "ransackable_associations": [
    {
      "className": "TenantShopSetting::Translation",
      "collectionName": null,
      "foreignKey": "tenant_shop_setting_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "photo_product_id",
      "name": "default_photo_product",
      "macro": "has_one",
      "resource_name": "PhotoProduct",
      "through": "default_tenant_photo_sheet_product"
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "resource_id",
      "name": "default_photo_sheet_product",
      "macro": "has_one",
      "resource_name": "PhotoSheetProduct",
      "through": "default_photo_product"
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "default_tenant_photo_sheet_product_id",
      "name": "default_tenant_photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantShopSetting::Translation",
      "collectionName": null,
      "foreignKey": "tenant_shop_setting_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "default_tenant_photo_sheet_product_id",
      "column": {
        "default": null,
        "name": "default_tenant_photo_sheet_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "greeter_text",
      "column": {
        "default": null,
        "name": "greeter_text",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "opening_hours",
      "column": {
        "default": null,
        "name": "opening_hours",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "pick_up_enabled",
      "column": {
        "default": true,
        "name": "pick_up_enabled",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vimeo_greeter_identifier",
      "column": {
        "default": null,
        "name": "vimeo_greeter_identifier",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "default_tenant_photo_sheet_product_id",
      "name": "default_tenant_photo_sheet_product",
      "macro": "belongs_to",
      "resource_name": "TenantPhotoProduct",
      "through": null
    }
  ],
  "paramKey": "tenant_shop_setting",
  "primaryKey": "id"
}

/** Frontend model for TenantShopSetting. */
export default class TenantShopSetting extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  cookiesAndPrivacyPolicy() {
    return this.readAttributeUnderscore("cookies_and_privacy_policy")
  }

  /** @returns {boolean} */
  hasCookiesAndPrivacyPolicy() {
    const value = this.cookiesAndPrivacyPolicy()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  defaultTenantPhotoSheetProductId() {
    return this.readAttributeUnderscore("default_tenant_photo_sheet_product_id")
  }

  /** @returns {boolean} */
  hasDefaultTenantPhotoSheetProductId() {
    const value = this.defaultTenantPhotoSheetProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  greeterText() {
    return this.readAttributeUnderscore("greeter_text")
  }

  /** @returns {boolean} */
  hasGreeterText() {
    const value = this.greeterText()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  openingHours() {
    return this.readAttributeUnderscore("opening_hours")
  }

  /** @returns {boolean} */
  hasOpeningHours() {
    const value = this.openingHours()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  pickUpEnabled() {
    return this.readAttributeUnderscore("pick_up_enabled")
  }

  /** @returns {boolean} */
  hasPickUpEnabled() {
    const value = this.pickUpEnabled()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  termsAndConditions() {
    return this.readAttributeUnderscore("terms_and_conditions")
  }

  /** @returns {boolean} */
  hasTermsAndConditions() {
    const value = this.termsAndConditions()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  vimeoGreeterIdentifier() {
    return this.readAttributeUnderscore("vimeo_greeter_identifier")
  }

  /** @returns {boolean} */
  hasVimeoGreeterIdentifier() {
    const value = this.vimeoGreeterIdentifier()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  vimeoGreeterEmbeddedHtml(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "vimeo_greeter_embedded_html",
        primaryKey: this.primaryKey(),
        collectionName: "tenant_shop_settings",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./tenant-photo-product.js").default | null} */
  defaultTenantPhotoSheetProduct() {
    return this._readBelongsToReflection({modelClass: TenantPhotoProduct, reflectionName: "default_tenant_photo_sheet_product"})
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  loadDefaultTenantPhotoSheetProduct() {
    if (!("defaultTenantPhotoSheetProductId" in this)) throw new Error("Foreign key method wasn't defined: defaultTenantPhotoSheetProductId")

    const id = this.defaultTenantPhotoSheetProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "default_tenant_photo_sheet_product",
        model: this,
        modelClass: TenantPhotoProduct
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant-photo-product.js").default | null>} */
  ensureDefaultTenantPhotoSheetProductLoaded() {
    return this.ensureAssociationLoaded("default_tenant_photo_sheet_product")
  }
}
